import { Box, Grid, GridProps, Paper, styled } from "@mui/material";
import { FC } from "react";

export const GridColumn:FC<GridProps> = (props: GridProps) => {
    return (
        <Grid 
            container
            direction="column"
            size={{
                xs: 12,
                md: 12
            }}
            sx={{
                flex: "1 1 auto",
                alignSelf: 'stretch'
            }}

            {...props} 
        />
    );
}

export const UnstyledGridLabel:FC<GridProps> = (props: GridProps) => {
    return (
        <Grid 
            size={{
                xs: 6,
                sm: 6
            }}
            {...props}
        />
    );
}
export const GridLabel = styled(UnstyledGridLabel) (({theme}) => ({
    backgroundColor: theme.palette.grey['300'],
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(2)
}))

export const UnstyledGridData:FC<GridProps> = (props: GridProps) => {
    return (
        <Grid 
            size={{
                xs: 6,
                sm: 6
            }}
            {...props} 
        />
    )
}

export const GridData = styled(UnstyledGridData) (({theme}) => ({
    alignContent: "flex-end",
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2)
}));

export const GridRow:FC<GridProps> = (props: GridProps) => {
    return (
        <Grid
            container
            size={{
                xs: 12
            }}
            {...props}
        />
    );
}

export const GridFillerRow:FC<GridProps> = (props: GridProps) => {
    return (
        <GridRow 
            sx={{
                flex: '1 1 auto'
            }}
            {...props}
        >
            <GridLabel />
            <GridData />
        </GridRow>
    );
}

export const DetailsPanel = styled(Paper) (() => ({
    overflow: 'hidden',
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column'
}))

export const DetailsHeader = styled(Box) (({theme}) => ({
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    width: '100%',
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.common.white
}));

export const DetailsContent:FC<GridProps> = (props: GridProps) => {
    return (
        <Grid 
            container 
            sx={{
                flex: '1 1 auto'
            }}
            {...props} 
        />
    );
}